import type { SelectItemProps } from '@radix-ui/react-select';
import type { FC } from 'react';
import type { PickProps } from '@/ui/types/types';
import * as RadixSelect from '@radix-ui/react-select';
import clsx from 'clsx';
import { motion } from 'framer-motion';
import styles from './SelectItem.module.css';

export const SelectItem: FC<SelectItemProps & PickProps<'div', 'ref'>> = ({ className, children, ...props }) => (
    <RadixSelect.Item
        asChild
        className={clsx(styles.item, className)}
        {...props}
    >
        <motion.div
            initial={{ scale: 1 }}
            whileHover={{ scale: 1.01 }}
            whileTap={{ scale: 0.98 }}
        >
            <RadixSelect.ItemText>{children}</RadixSelect.ItemText>
        </motion.div>
    </RadixSelect.Item>
);
